module.exports = __webpack_public_path__ + "img/download.8963f72c.svg";